
import block_icons from '../icons/blockqoute';
import { font_family_detailed, all_font_families } from '../gb-helper/font_family_detailed';
import color_palette_list from '../gb-helper/color_palette';
import React from 'react';
const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { RichText, InspectorControls, MediaUpload, MediaUploadCheck } = wp.editor;
const { PanelBody, PanelRow, SelectControl, TextControl, Card, CardBody, Dashicon,
    ToggleControl, Button, RangeControl, TabPanel, ColorPalette, ColorIndicator } = wp.components;

registerBlockType('blocksbakery/block-quote', {
    title: __("Blockquote", "blocks-bakery"),
    description: __("This block allows you to display your Blockquote.", "blocks-bakery"),
    icon: block_icons.qoute_icon,
    category: 'blocks-bakery',
    keywords: [
        __('block', 'blocks-bakery'),
        __('blockquote', 'blocks-bakery'),
        __('quote', 'blocks-bakery')
    ],
    attributes: {
        img_ID: {
            type:                       'number'
        },
        img_URL: {
            type:                       'string',
            source:                     'attribute',
            attribute:                  'src',
            selector:                   'img'
        },
        img_alt: {
            type:                       'string',
            source:                     'attribute',
            attribute:                  'alt',
            selector:                   'img'
        },
        author_name: {
            type: 'string',
            default: 'Author'
        },
        quotation: {
            type: "string",
            default: "Click here to change this text. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo."
        },
        label_value: {
            type: 'string',
            default: 'Tweet'
        },
        vertical_padding: {
            type: 'number',
            default:0
        },
        qoute_border_style: {
            type: 'string',
            default: 'solid'
        },
        quote_color: {
            type: 'string',
        },
        icon_text_space: {
            type: 'number',
            default: 3
        },
        author_color: {
            type: 'string'
        },
        padding_tb: {
            type: 'number',
            default: 10
        },
        padding_lr: {
            type: 'number',
            default: 10
        },
        tweet_color: {
            type: 'string',
        },
        tweet_background_color: {
            type: 'string',
        }, 
        border_quote_gap: {
            type: 'number',
            default: 15
        },
        quote_bottom_spacing: {
            type: 'number',
            default:0
        },
        border_width: {
            type: 'number',
            default: 4
        },
        bgTweetDisp: {
            type: 'string',
            default: 'block'
        },
        twitterDisp: {
            type: 'string',
            default: 'inline-block'
        },
        border_color: {
            type: 'string',
        },
        author_img_border_radius: {
            type: 'number',
            default: 50
        },
        quote_icon_size: {
            type: 'number',
            default: 20
        },
        icon_background_size: {
            type: 'number',
            default: 10
        },
        quote_border_radius: {
            type: 'number',
            default: 50
        },
        quote_icon_color: {
            type: 'string',
        },
        quote_icon_background_color: {
            type: 'string',
        },
        author_img_width: {
            type: 'number',
            default: 40,
        },
        tweetDisplay: {
            type: 'string',
            default: 'block'
        },
        linkDisplay: {
            type: 'string',
            default: 'none'
        },
        author_img_position:
        {
            type: 'string',
            default: 'left'
        },
        tweet_icon: {
            type: 'string'
        },
        tweet_icon: {
            type: 'string'
        },
        icon: {
            type: 'string'
        },
        tweet: {
            type: 'string'
        },
        author_img_size:
        {
            type: 'html',
            default: 'fill',
        },
        quote_size: {
            type: 'number',
            default:16
        },
        bubbleDisp: {
            type: 'string'
        },
        font_family_quote: {
            type: 'string',
            default: 'ABeeZee'
        },
        quote_weight: {
            type: 'string',
            default:"regular"
        },
        line_height_quote: {
            type: 'number',
            default:1.5
        },
        author_size: {
            type: 'number',
            default:20
        },
        font_family_author: {
            type: 'string',
            default: 'ABeeZee'
        },
        author_weight: {
            type: 'string',
            default:"regular"
        },
        line_height_author: {
            type: 'number',
            default:1.5
        },
        quoteDisp: {
            type: 'string',
            default: 'none'
        },
        borderLeftDisplay: {
            type: 'string',
            default: 'solid'
        },
        tweet_size: {
            type: 'number',
            default: 20
        },
        font_family_tweet: {
            type: 'string',
            default: 'ABeeZee'
        },
        tweet_weight: {
            type: 'string',
            default:'regular'
        },
        line_height_tweet: {
            type: 'number',
            default:1.5
        },
        URL_value: {
            type: 'string'
        },
        qoute_style: {
            type:'string',
            default:"modern"
        },
        twitter_icon: {
            type: 'boolean',
            default: true
        },
        custom_url_value: {
            type: 'string',
            default: "#"
        },
        link_tweet_color: {
            type: 'string',
        },
        link_tweet_hover_color: {
            type: 'string'
        },
        layout_setting1: {
            type: 'string',
        },
        leftImgDisp: {
            type: 'string',
            default: 'inline-block'
        },
        rightImgDisp: {
            type: 'string',
            default: 'none'
        },
        layout_setting2: {
            type: 'string'
        },
        layout_settingleft: {
            type: 'string',
        },
        layout_settingright: {
            type: 'string',
        },
        layout_settingtop: {
            type: 'string',
        },
        icon_view:{
            type:"string",
            default:"icontext"
        },
        icon_style:{
            type:"string",
            default:"bubble"
        },
        quoteFontEm_pxem:{
            type: 'string',
            default: 'px'
        },
        line_height_px_em:{
            type: 'string',
            default:'em',
        },
        autorsize_px_em:{
            type:'string',
            default:'px',
        },
        tweet_px_em_size:{
            type:'string',
            default:'px',
        },
        tweelineheightpxem:{
            type:'string',
            default:'em'
        },
        qouteicon_px_em:{
            type:'string',
            default:'px'
        },
        bgqouteicon_px_em:{
            type:'string',
            default:'px'
        },
        lineheightauthor_px:{
            type:"string",
            default:"em"
        },
        border_hover_color:{
            type:"string"
        },
        quote_icon_hover_color:{
            type:"string"
        },
        quote_icon_background_hover_color:{
            type:"string"
        },
        tweet_background_hover_color:{
            type:"string"
        }
    },

    edit: (props) => {

        
        var index = font_family_detailed.findIndex(x => x.family === props.attributes.font_family_quote);
        var font_weight = font_family_detailed[index].variants
        var font_weight_list = []
        for (var i = 0; i < font_weight.length; i++) {
            font_weight_list.push({ label: font_weight[i], value: font_weight[i] })
        }
    
            
        var indexauthor = font_family_detailed.findIndex(y => y.family === props.attributes.font_family_author);
        var font_weight_author = font_family_detailed[indexauthor].variants
        var font_weight_list_author = []
        for (var i = 0; i < font_weight_author.length; i++) {
            font_weight_list_author.push({ label: font_weight_author[i], value: font_weight_author[i] })
        }

               
        var indextweet = font_family_detailed.findIndex(z => z.family === props.attributes.font_family_tweet);
        var font_weight_tweetr = font_family_detailed[indextweet].variants
        var font_weight_list_twet = []
        for (var i = 0; i < font_weight_tweetr.length; i++) {
            font_weight_list_twet.push({ label: font_weight_tweetr[i], value: font_weight_tweetr[i] })
        }



        const quoteReset = () => {   
                props.setAttributes({ quote_size: 16 })
                props.setAttributes({ font_family_quote: 'ABeeZee' })
                props.setAttributes({ line_height_quote: 1.5 })
                props.setAttributes({ quote_weight: 'regular' })
            
        }
        const authorReset = () => {
            props.setAttributes({ author_size: 20 })
            props.setAttributes({ font_family_author: 'ABeeZee' })
            props.setAttributes({ line_height_author: 1.5 })
            props.setAttributes({ author_weight: 'regular' })
        }
        const tweetReset = () => {
            props.setAttributes({ tweet_size: 20 })
            props.setAttributes({ font_family_tweet: 'ABeeZee' })
            props.setAttributes({ line_height_tweet: 1.5 })
            props.setAttributes({ tweet_weight: 'regular' })
        }
        const quote_card = () => {
            var x = document.getElementById("myDIV1");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        }
        const author_card = () => {
            var x = document.getElementById("myDIV2");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        }
        const tweet_card = () => {
            var x = document.getElementById("myDIV3");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        }
        const quoteFontPx = () => {
            var quotefontpx = document.getElementById("quotefontpx");
            var quotefontem = document.getElementById("quotefontem");
            quotefontpx.style.textDecoration = "underline";
            quotefontem.style.textDecoration = "none";
            props.setAttributes({quoteFontEm_pxem: 'px'})
            
        }
        const quoteFontEm = () => {
            var quotefontpx = document.getElementById("quotefontpx");
            var quotefontem = document.getElementById("quotefontem");
            quotefontpx.style.textDecoration = "none";
            quotefontem.style.textDecoration = "underline";
            props.setAttributes({quoteFontEm_pxem: 'em'})
            
        }
        
        const quoteLineheihgtPx = () => {
            var authorlineheihgtpx = document.getElementById('quotelineheightpx');
            var authorlineheihgtem = document.getElementById('quotelineheightem');
            props.setAttributes({ line_height_px_em: 'px' })
            authorlineheihgtpx.style.textDecoration = "underline";
            authorlineheihgtem.style.textDecoration = "none";
        }
        const quoteLineheihgtEm = () => {
            var authorlineheihgtpx = document.getElementById('quotelineheightpx');
            var authorlineheihgtem = document.getElementById('quotelineheightem');
            props.setAttributes({ line_height_px_em: 'em' })
            authorlineheihgtpx.style.textDecoration = "none";
            authorlineheihgtem.style.textDecoration = "underline";
        }
        const authorFontPx = () => {
            var range = document.getElementById('author')
            var authorfontpx = document.getElementById('authorfontpx');
            var authorfontem = document.getElementById('authorfontem');
            props.setAttributes({ autorsize_px_em: 'px' })
            authorfontpx.style.textDecoration = "underline";
            authorfontem.style.textDecoration = "none";
        }
        const authorFontEm = () => {
            var range = document.getElementById('author')
            props.setAttributes({ autorsize_px_em: 'em' })
            var authorfontpx = document.getElementById('authorfontpx');
            var authorfontem = document.getElementById('authorfontem');
            authorfontpx.style.textDecoration = "none";
            authorfontem.style.textDecoration = "underline";
        }
        const authorLineheihgtPx = () => {
            var authorlineheightemx = document.getElementById('authorlineheightemx');
            var authorlineheightpxx = document.getElementById('authorlineheightpxx');
            props.setAttributes({lineheightauthor_px:'px'})
            authorlineheightemx.style.textDecoration = "underline";
            authorlineheightpxx.style.textDecoration = "none";
        }
        const authorLineheihgtEm = () => {
            var authorlineheightemx = document.getElementById('authorlineheightemx');
            var authorlineheightpxx = document.getElementById('authorlineheightpxx');
            props.setAttributes({lineheightauthor_px:'em'})
            authorlineheightemx.style.textDecoration = "none";
            authorlineheightpxx.style.textDecoration = "underline";
        }
        const iconStyle = (val) => {
            var spacing= document.getElementById("link_btn_padding")
            if (val === 'classic') {
                spacing.style.display='block'
                props.setAttributes({ bubbleDisp: 'none' })
                props.setAttributes({ tweet_background_color: props.attributes.tweet_background_color })
                props.setAttributes({ tweet_color: props.attributes.tweet_color })
                props.setAttributes({ tweetDisplay: 'block' })
                props.setAttributes({ linkDisplay: 'none' })
            } else if (val === 'bubble') {
                spacing.style.display='block'
                props.setAttributes({ bubbleDisp: 'inline-block' })
                props.setAttributes({ tweet_background_color: props.attributes.tweet_background_color })
                props.setAttributes({ tweet_color: props.attributes.tweet_color })
                props.setAttributes({ tweetDisplay: 'block' })
                props.setAttributes({ linkDisplay: 'none' })
            } else if (val === 'link') {
                spacing.style.display='none'
                props.setAttributes({ bubbleDisp: 'none' })
                props.setAttributes({ tweetDisplay: 'none' })
                props.setAttributes({ linkDisplay: 'block' })
            }
        }
        const tweetFontPx = () => {
            var a = document.getElementById('tweetFontPx');
            var b = document.getElementById('tweetFontEm');
            a.style.textDecoration = "underline";
            b.style.textDecoration = "none";
            props.setAttributes({tweet_px_em_size: 'px'})
        
        }
        const tweetFontEm = () => {
            var a = document.getElementById('tweetFontPx');
            var b = document.getElementById('tweetFontEm');
            a.style.textDecoration = "none";
            b.style.textDecoration = "underline";
            props.setAttributes({tweet_px_em_size: 'em'})   
        }
        const tweetLineheihgtPx = () => {
            var a = document.getElementById('tweetLineheihgtPx');
            var b = document.getElementById('tweetLineheihgtEm');
            a.style.textDecoration = "underline";
            b.style.textDecoration = "none";
            props.setAttributes({tweelineheightpxem: 'px'})
        }
        const tweetLineheihgtEm = () => {
            var a = document.getElementById('tweetLineheihgtPx');
            var b = document.getElementById('tweetLineheihgtEm');
            a.style.textDecoration = "none";
            b.style.textDecoration = "underline";
            props.setAttributes({tweelineheightpxem: 'em'})
        }
        const url_value = (val) => {
            var custom_URL = document.getElementById('custom-url')
            if (val === 'current') {
                custom_URL.style.display = 'none'
            } 
            else if (val === 'custom') {
                custom_URL.style.display = 'block'
            }
        }
        const select_img = (img) => {
            props.setAttributes({
                img_ID: img.id,
                img_URL: img.url,
                img_alt: img.alt
            })
        };
        const remove_img = () => {
            props.setAttributes({
                img_ID: null,
                img_URL: null,
                img_alt: null
            })
        };
        const twitterIcon = (val) => {
            var y = document.getElementById('body_dismiss')
            if (val === true) {
                props.setAttributes({ twitterDisp: 'inline-block' })
                y.style.display = 'block'
            } else if (val === false) {
                props.setAttributes({ twitterDisp: 'none' })
                y.style.display = "none";
            }
        }
        const layoutStyle = (val) => {
            var x = document.getElementById("modern");
            var y = document.getElementById("quotation");
            if (val === "modern") {
                x.style.display = "block";
                props.setAttributes({ qoute_border_style: 'solid' })
                y.style.display = "none";
                props.setAttributes({ quoteDisp: 'none' })
            } else if (val === "quotation") {
                y.style.display = "block";
                props.setAttributes({ qoute_border_style: 'none' })
                x.style.display = "none";
                props.setAttributes({ quoteDisp: 'block' })
            }
        };
        const iconView = (val) => {
            if (val === 'icontext') {
                props.setAttributes({ tweetIcon: 'inline-block' })
                props.setAttributes({ tweet: 'inline-block' })
                props.setAttributes({ label: 'block' })
            } else if (val === 'icon') {
                props.setAttributes({ tweetIcon: 'inline-block' })
                props.setAttributes({ tweet: 'none' })
                props.setAttributes({ label: 'block' })
            } else if (val === 'text') {
                props.setAttributes({ tweetIcon: 'none' })
                props.setAttributes({ tweet: 'inline-block' })
                props.setAttributes({ label: 'block' })
            }
        }
        const onChangeIcon = (e) => {
            e.target.style.color = props.attributes.quote_icon_hover_color
            e.target.style.backgroundColor = props.attributes.quote_icon_background_hover_color
        }
        const sameIcon = (e) => {
            e.target.style.color = props.attributes.quote_icon_color
            e.target.style.backgroundColor = props.attributes.quote_icon_background_color
        }
        const onChnageTweet = (e) => {
            e.target.style.color = props.attributes.tweet_hover_color
            e.target.style.backgroundColor = props.attributes.tweet_background_hover_color
        }
        const sameTweet = (e) => {
            e.target.style.color = props.attributes.tweet_color
            e.target.style.backgroundColor = props.attributes.tweet_background_color
        }
        const onChnageTweetIcon = (e) => {
            e.target.style.color = props.attributes.tweet_hover_color
            e.target.style.backgroundColor = ''
        }
        const sameTweetIcon = (e) => {
            e.target.style.color = props.attributes.tweet_color
            e.target.style.backgroundColor = ''
        }
        const onChnageTweetLink = (e) => {
            e.target.style.color = props.attributes.link_tweet_hover_color
        }
        const sameTweetLink = (e) => {
            e.target.style.color = props.attributes.link_tweet_color
        }
        const onChnageTweetText = (e) => {
            e.target.style.color = props.attributes.tweet_hover_color
            e.target.style.backgroundColor = props.attributes.tweet_background_hover_color
        }
        const sameTweetText = (e) => {
            e.target.style.color = props.attributes.tweet_color
            e.target.style.backgroundColor = props.attributes.tweet_background_color
        }
        const onChnageBubble = (e) => {
            e.target.style.color = props.attributes.tweet_background_hover_color
        }
        const sameBubble = (e) => {
            e.target.style.color = props.attributes.tweet_background_color
        }
        const changeBorder = (e) => {
            e.target.style.borderColor = props.attributes.border_hover_color
        }
        const sameColor = (e) => {
            e.target.style.borderColor = props.attributes.border_color
        };
        const quoteIconPx = () => {
            var quoteiconpx = document.getElementById("quoteiconpx");
            var quoteiconem = document.getElementById("quoteiconem");
            quoteiconpx.style.textDecoration = "underline";
            quoteiconem.style.textDecoration = "none";
            props.setAttributes({ qouteicon_px_em: 'px' })
        }
        const quoteIconEm = () => {
            var quoteiconpx = document.getElementById("quoteiconpx");
            var quoteiconem = document.getElementById("quoteiconem");
            quoteiconpx.style.textDecoration = "none";
            quoteiconem.style.textDecoration = "underline";
            props.setAttributes({ qouteicon_px_em: 'em' })
        }
        const backgroundSizePx = () => {
            var backgroundsizepx = document.getElementById("backgroundsizepx");
            var backgroundsizeem = document.getElementById("backgroundsizeem");
            backgroundsizepx.style.textDecoration = "underline";
            backgroundsizeem.style.textDecoration = "none";
            props.setAttributes({ bgqouteicon_px_em: 'px' })
        }
        const backgroundSizeEm = () => {
            var backgroundsizepx = document.getElementById("backgroundsizepx");
            var backgroundsizeem = document.getElementById("backgroundsizeem");
            backgroundsizepx.style.textDecoration = "none";
            backgroundsizeem.style.textDecoration = "underline";
            props.setAttributes({ bgqouteicon_px_em: 'em' })
        }

        return (
            <React.Fragment>
                <InspectorControls>
                    <PanelBody title={__('Layout', 'block-list')}>
                        <SelectControl
                            label={__("Layout", 'block-quote')}
                            value={props.attributes.qoute_style}
                            options={[
                                { label: 'Modern', value: 'modern' },
                                { label: 'Quotation', value: 'quotation' },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ qoute_style: new_val })
                                layoutStyle(new_val)
                            }}
                        />
                        <hr></hr>
                        <div id='modern'>
                            <h2>Modern Layout -Styling</h2>
                            <SelectControl
                                label={__("Quote Border Style", 'block-quote')}
                                value={props.attributes.qoute_border_style}
                                options={[
                                    { label: 'None', value: 'none' },
                                    { label: 'Solid', value: 'solid' },
                                    { label: 'Dotted', value: 'dotted' },
                                    { label: 'Dashed', value: 'dashed' },
                                    { label: 'Double', value: 'double' },
                                    { label: 'Groove', value: 'groove' },
                                    { label: 'inset', value: 'inset' },
                                    { label: 'outset', value: 'outset' },
                                    { label: 'Ridge', value: 'ridge' },
                                ]}
                                onChange={(new_val) => {
                                    props.setAttributes({ qoute_border_style: new_val })
                                }}
                            />
                            <p>Thickness (px) </p>
                            <div className="range-controler" style={{display:"flex"}}>
                            <div style={{marginRight:"10px",width:"100%"}}>
                            <RangeControl
                                step={0.1}
                                min={0}
                                max={50}
                                initialPosition={4}
                                value={props.attributes.border_width}
                                onChange={(new_val) => {
                                    props.setAttributes({ border_width: new_val })
                                }}
                            />
                            </div>
                            <Button style={{
                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                            }}
                            onClick={() => {
                            props.setAttributes({border_width:4})
                            }}> Reset 
                            </Button>
                            </div>

                            <TabPanel className="my-tab-panel"
                                activeClass="active-tab"
                                tabs={[
                                    {
                                        name: <ColorPalette
                                            value={props.attributes.border_color}
                                            colors={color_palette_list}
                                            onChange={(new_val) => {
                                                props.setAttributes({ border_color: new_val })
                                            }}
                                        />,
                                        value: <ColorIndicator colorValue={props.attributes.border_color} />,
                                        title: 'Normal',
                                        className: 'tab-one',
                                    },
                                    {
                                        name: <ColorPalette
                                            colors={color_palette_list}
                                            value={props.attributes.border_hover_color}
                                            onChange={(new_value) => {
                                                props.setAttributes({ border_hover_color: new_value })
                                            }}
                                        />,
                                        value: <ColorIndicator colorValue={props.attributes.border_hover_color} />,
                                        title: "Hover",
                                        className: 'tab-two',
                                    },
                                ]}>
                                {
                                    (tab) =>
                                        <div className={props.className}   >
                                            <p>{tab.button}</p>
                                            <p>{tab.title} Color {tab.value}</p>
                                            <p>{tab.name}</p>
                                        </div>
                                }
                            </TabPanel>
                        </div>

                        <div id='quotation' style={{ display: 'none' }}>
                            <h2>Quotation Layout -Styling</h2>
                            <PanelRow>
                                <p style={{ marginTop: 5 }}>Quote Icon Size</p>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button onClick={quoteIconPx} primaray id="quoteiconpx" style={{textDecoration:"underline", fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button onClick={quoteIconEm} primaray id="quoteiconem" style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                </div>
                            </PanelRow>
                            <div className="range-controler" style={{ display: "flex" }}>
                            <div style={{ marginRight: "10px", width: "100%" }}>
                            <RangeControl
                                beforeIcon="editor-textcolor"
                                initialPosition={20}
                                min={1}
                                max={500}
                                step={0.1}
                                value={props.attributes.quote_icon_size}
                                onChange={(new_val) => {
                                    props.setAttributes({ quote_icon_size: new_val })
                                }
                                }
                            />
                            </div>
                            <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba"
                                        }}
                                            onClick={() => {
                                                props.setAttributes({ quote_icon_size:20 })
                                            }}> Reset
                            </Button>
                            </div>
                            <PanelRow>
                                <p style={{ marginTop: 5 }}>Background Size</p>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button onClick={backgroundSizePx} id="backgroundsizepx" primaray style={{textDecoration:"underline", fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button onClick={backgroundSizeEm} id="backgroundsizeem" primaray style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                </div>
                            </PanelRow>
                            <div className="range-controler" style={{ display: "flex" }}>
                            <div style={{ marginRight: "10px", width: "100%" }}>
                            <RangeControl
                                beforeIcon="editor-textcolor"
                                initialPosition={10}
                                min={1}
                                max={500}
                                step={0.1}
                                value={props.attributes.icon_background_size}
                                onChange={(new_val) => {
                                    props.setAttributes({ icon_background_size: new_val })
                                }
                                }
                            />
                            </div>
                            <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba"
                                        }}
                                            onClick={() => {
                                                props.setAttributes({ icon_background_size: 10 })
                                            }}> Reset
                            </Button>
                            </div>
                            <PanelRow>
                                <p style={{ marginTop: 5 }}>Quote Icon Border Radius %</p>
                            </PanelRow>
                            <div className="range-controler" style={{ display: "flex" }}>
                            <div style={{ marginRight: "10px", width: "100%" }}>
                            <RangeControl
                                beforeIcon="editor-textcolor"
                                initialPosition={50}
                                min={1}
                                max={50}
                                step={0.1}
                                value={props.attributes.quote_border_radius}
                                onChange={(new_val) => {
                                    props.setAttributes({ quote_border_radius: new_val })
                                }
                                }
                            />
                            </div>
                            <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba"
                                        }}
                                            onClick={() => {
                                                props.setAttributes({ quote_border_radius: 50 })
                                            }}> Reset
                            </Button>
                            </div>
                            <hr />
                            <h2>Quote Icon Colors</h2>
                            <TabPanel className="my-tab-panel"
                                activeClass="active-tab"
                                tabs={[
                                    {
                                        name: {
                                            n1: <ColorPalette
                                                value={props.attributes.quote_icon_color}
                                                colors={color_palette_list}
                                                onChange={(new_val) => {
                                                    props.setAttributes({ quote_icon_color: new_val })
                                                }}
                                            />,
                                            n2: <ColorPalette
                                                value={props.attributes.quote_icon_background_color}
                                                colors={color_palette_list}
                                                onChange={(new_val) => {
                                                    props.setAttributes({ quote_icon_background_color: new_val })
                                                }}
                                            />,
                                        },
                                        value: {
                                            v1: <ColorIndicator colorValue={props.attributes.quote_icon_color} />,
                                            v2: <ColorIndicator colorValue={props.attributes.quote_icon_background_color} />,
                                        },
                                        title: 'Icon',
                                        className: 'tab-one',
                                    },
                                    {
                                        name: {
                                            n1: <ColorPalette
                                                colors={color_palette_list}
                                                value={props.attributes.quote_icon_hover_color}
                                                onChange={(new_value) => {
                                                    props.setAttributes({ quote_icon_hover_color: new_value })
                                                }}
                                            />,
                                            n2: <ColorPalette
                                                colors={color_palette_list}
                                                value={props.attributes.quote_icon_background_hover_color}
                                                onChange={(new_value) => {
                                                    props.setAttributes({ quote_icon_background_hover_color: new_value })
                                                }}
                                            />,
                                        },
                                        value: {
                                            v1: <ColorIndicator colorValue={props.attributes.quote_icon_background_color} />,
                                            v2: <ColorIndicator colorValue={props.attributes.quote_icon_background_hover_color} />,
                                        },
                                        title: "Hover",
                                        className: 'tab-two',
                                    },
                                ]}>
                                {
                                    (tab) =>
                                        <div className={props.className}>
                                            <p>{tab.button}</p>
                                            <p>{tab.title} Color {tab.value.v1}</p>
                                            <p>{tab.name.n1}</p>
                                            <hr />
                                            <p>{tab.title} Background Color{tab.value.v2}</p>
                                            <p>{tab.name.n2}</p>
                                            <hr />
                                        </div>
                                }
                            </TabPanel>
                        </div>
                    </PanelBody>
                    <PanelBody title={__('Content', 'block-list')} initialOpen={false}>
                        <h2>Quote</h2>
                        <PanelRow>
                            <p>Typography</p>
                            <div>
                                <Button onClick={quoteReset} style={{ padding: 0 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                                <Button><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} onClick={quote_card} /></span></Button>
                            </div>
                        </PanelRow>
                        <Card id="myDIV1" style={{ display: "none" }}>
                            <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ marginRight: 46 }}>Font Size</p>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button onClick={quoteFontPx} id="quotefontpx" primaray style={{textDecoration:"underline", fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button onClick={quoteFontEm} id="quotefontem" primaray style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                </div>
                                <div className="range-controller-main">
                                    <div className="textcoloring">
                                    </div>
                                    <div className="range-controler" style={{display:"flex"}}>
                                    <div style={{marginRight:"10px",width:"100%"}}>
                                        <RangeControl  
                                            beforeIcon="editor-textcolor"
                                            min={0}
                                            max={100}
                                            step={0.1}
                                            initialPosition={16}
                                            value={props.attributes.quote_size}
                                            onChange={(new_val) => {
                                                props.setAttributes({ quote_size: new_val })
                                            }}
                                        />
                                        </div>
                                        <  Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({quote_size:16})
                                            }}> Reset 
                                        </Button>

                                    </div>
                                    <SelectControl
                                        label="Font Family"
                                        options={all_font_families}
                                        onChange={(new_val) => {
                                            props.setAttributes({ font_family_quote: new_val })
                                        }}
                                        value={props.attributes.font_family_quote}
                                    />
                                    <SelectControl
                                        label="Font Weight"
                                        options={font_weight_list}
                                        onChange={(new_val) => {
                                            props.setAttributes({ quote_weight: new_val })
                                        }}
                                        value={props.attributes.quote_weight}
                                    />
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <p style={{ marginRight: 30 }}>Line Height</p>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                        <Button onClick={quoteLineheihgtPx} id="quotelineheightpx" primaray style={{ fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                        <Button onClick={quoteLineheihgtEm} id="quotelineheightem" primaray style={{textDecoration:"underline", fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                    </div>
                                    <div style={{display:"flex"}}>
                                    <div style={{marginRight:"10px",width:"100%"}}> 
                                    <RangeControl
                                        beforeIcon="editor-textcolor"
                                        initialPosition={1.5}
                                        step={0.1}
                                        min={0}
                                        max={100}
                                        onChange={(new_val) => {
                                            props.setAttributes({ line_height_quote: new_val })
                                        }}
                                        value={props.attributes.line_height_quote}
                                    />
                                    </div>
                                          <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({line_height_quote:1.5})
                                            }}> Reset 
                                        </Button>
                                </div>
                                </div>
                            </CardBody>
                        </Card>
                        <p>Quote Color<span>
                            <ColorIndicator
                                style={{ backgroundColor: props.attributes.quote_color }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ quote_color: new_val })
                            }}
                            value={props.attributes.quote_color}
                        />
                        <hr />
                        <h2>Author</h2>
                        <PanelRow>
                            <p>Typography</p>
                            <div>
                                <Button onClick={authorReset} style={{ padding: 0 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                                <Button><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} onClick={author_card} /></span></Button>
                            </div>
                        </PanelRow>
                        <Card id="myDIV2" style={{ display: "none" }}>
                            <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ marginRight: 46 }}>Font Size</p>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button onClick={authorFontPx} id="authorfontpx" primaray style={{textDecoration:"underline", fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button onClick={authorFontEm} id="authorfontem" primaray style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                </div>
                                <div className="range-controller-main">
                                    <div className="textcoloring">
                                    </div>
                                    <div className="range-controler" style={{display:"flex"}}>
                                    <div style={{marginRight:"10px",width:"100%"}}>
                                        <RangeControl
                                            beforeIcon="editor-textcolor"
                                            min={0}
                                            max={100}
                                            step={0.1}
                                            initialPosition={20}
                                            value={props.attributes.author_size}
                                            onChange={(new_val) => {
                                                props.setAttributes({ author_size: new_val })
                                            }}
                                        />
                                        </div>
                                        <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({author_size:20})
                                            }}> Reset 
                                        </Button>

                                    </div>
                                    <SelectControl
                                        label="Font Family"
                                        options={all_font_families}
                                        onChange={(new_val) => {
                                            props.setAttributes({ font_family_author: new_val })
                                        }}
                                        value={props.attributes.font_family_author}
                                    />
                                    <SelectControl
                                        label="Font Weight"
                                      options={font_weight_list_author}
                                        onChange={(new_val) => {
                                            props.setAttributes({ author_weight: new_val })
                                        }}
                                        value={props.attributes.author_weight}
                                    />
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <p style={{ marginRight: 30 }}>Line Height</p>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                        <Button onClick={authorLineheihgtPx} id="authorlineheightemx" primaray style={{ fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                        <Button onClick={authorLineheihgtEm} id="authorlineheightpxx" primaray style={{textDecoration:"underline", fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                    </div>

                                      <div  style={{display:"flex"}}>
                                    <div style={{marginRight:"10px",width:"100%"}}>
                                    <RangeControl
                                        beforeIcon="editor-textcolor"
                                        initialPosition={1.5}
                                        step={0.1}
                                        min={0}
                                        max={100}
                                        onChange={(new_val) => {
                                            props.setAttributes({ line_height_author: new_val })
                                        }}
                                        value={props.attributes.line_height_author}
                                    />
                                    </div>
                                    <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({line_height_author:1.5})
                                            }}> Reset 
                                        </Button>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <p>Author Color<span>
                            <ColorIndicator
                                style={{ backgroundColor: props.attributes.author_color }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ author_color: new_val })
                            }}
                            value={props.attributes.author_color}
                        />
                        <hr />
                        <div>
                            <span style={{ marginRight: '14px' }}> Author Image </span>
                            {props.attributes.img_ID ? (
                                <div className="image-ctr">
                                    <img src={props.attributes.img_URL}
                                        alt={props.attributes.img_alt} />

                                    {props.isSelected ? (
                                        <Button className="btn-remove" onClick={remove_img}>
                                            <Dashicon icon='no' size='20' />
                                        </Button>
                                    ) : null}
                                </div>
                            ) : (
                                <MediaUploadCheck>
                                    <MediaUpload
                                        allowedType={['image']}
                                        value={props.attributes.img_ID}
                                        onSelect={select_img}
                                        render={({ open }) => (
                                            <Button className={"button button-large"} onClick={open}>
                                                {__('Upload Image', 'block-quote')}
                                            </Button>
                                        )}></MediaUpload>
                                </MediaUploadCheck>
                            )}
                        </div>
                        <SelectControl
                            label={__("Author Image Position", 'quote-block')}
                            value={props.attributes.author_img_position}
                            options={[
                                { label: 'Left', value: 'row' },
                                { label: 'Right', value: 'row-reverse' },
                                { label: 'Top', value: 'column' },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ author_img_position: new_val })
                            }}
                        />
                        <SelectControl
                            label={__("Author Image Size", 'quote-block')}
                            value={props.attributes.author_img_size}
                            options={[
                                { label: 'Thumbnail', value: 'contain' },
                                { label: 'Medium', value: 'cover' },
                                { label: 'Large', value: 'fill' },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ author_img_size: new_val })
                            }}
                        />
                         <div className="range-controler" style={{display:"flex"}}>
                        <div style={{marginRight:"10px",width:"100%"}}>
                        <RangeControl
                            label='Author Image Width'
                            value={props.attributes.author_img_width}
                            min={0}
                            step={0.1}
                            max={100}
                            initialPosition={40}
                            onChange={(new_value) => {
                                props.setAttributes({ author_img_width: new_value })
                            }}
                        />
                        </div>
                        <Button style={{
                        background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba", marginTop:"25px"
                        }}
                        onClick={() => {
                        props.setAttributes({author_img_width:40})
                        }}> Reset 
                        </Button>
                        </div>

                        <div className="range-controler" style={{display:"flex"}}>
                        <div style={{marginRight:"10px",width:"100%"}}>
                        <RangeControl
                            label='Author Image Rounded Corners'
                            value={props.attributes.author_img_border_radius}
                            min={0}
                            step={0.1}
                            max={100}
                            onChange={(new_value) => {
                                props.setAttributes({ author_img_border_radius: new_value })
                            }}
                        />
                        </div>
                        <Button style={{
                        background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba", marginTop:"25px"
                        }}
                        onClick={() => {
                        props.setAttributes({author_img_border_radius:50})
                        }}> Reset 
                        </Button>
                        </div>
                    </PanelBody>

                    <PanelBody title={__('Twitter Icon', 'block-list')} initialOpen={false}>
                        <ToggleControl
                            label="Enable Twitter Icon"
                            checked={props.attributes.twitter_icon}
                            onChange={(new_val) => {
                                props.setAttributes({ twitter_icon: new_val })
                                twitterIcon(new_val)
                            }}
                        />
                        <div id="body_dismiss">
                            <SelectControl
                                label="Icon View"
                                options={[
                                    { label: 'Icon & Text', value: 'icontext' },
                                    { label: 'Icon', value: 'icon' },
                                    { label: 'Text', value: 'text' },
                                ]}
                                value={props.attributes.icon_view}
                                onChange={(new_val) => {
                                    props.setAttributes({ icon_view: new_val })
                                    iconView(new_val)
                                }}
                            />
                            <SelectControl
                                label="Icon Style"
                                options={[
                                    { label: 'Classic', value: 'classic' },
                                    { label: 'Bubble', value: 'bubble' },
                                    { label: 'Link', value: 'link' },
                                ]}
                                onChange={(new_val) => {
                                    props.setAttributes({ icon_style: new_val })
                                    iconStyle(new_val)
                                }}
                                value={props.attributes.icon_style}
                            />
                            <div id="labeel" style={{ display: props.attributes.label }}>
                                <TextControl
                                    label="Label"
                                    value={props.attributes.label_value}
                                    onChange={(new_val) => {
                                        props.setAttributes({ label_value: new_val })
                                    }}
                                />
                            </div>
                            <PanelRow>
                                <p>Typography</p>
                                <div>
                                    <Button onClick={tweetReset} style={{ padding: 0 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                                    <Button><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} onClick={tweet_card} /></span></Button>
                                </div>
                            </PanelRow>
                            <Card id="myDIV3" style={{ display: "none" }}>
                                <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <p style={{ marginRight: 46 }}>Font Size</p>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                        <Button id="tweetFontPx" onClick={tweetFontPx} primaray style={{ textDecoration: "underline", fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                        <Button id="tweetFontEm" onClick={tweetFontEm} primaray style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                    </div>
                                    <div className="range-controller-main">
                                        <div className="textcoloring">
                                        </div>
                                        <div className="range-controler" style={{display:"flex"}}>
                                        <div style={{marginRight:"10px",width:"100%"}}>
                                            <RangeControl
                                                beforeIcon="editor-textcolor"
                                                min={0}
                                                max={100}
                                                initialPosition={20}
                                                value={props.attributes.tweet_size}
                                                onChange={(new_val) => {
                                                    props.setAttributes({ tweet_size: new_val })
                                                }}
                                            />
                                            </div>

                                            <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({tweet_size:20})
                                            }}> Reset 
                                        </Button>
                                        </div>

                                        <SelectControl
                                            label="Font Family"
                                            options={all_font_families}
                                            onChange={(new_val) => {
                                                props.setAttributes({ font_family_tweet: new_val })
                                            }}
                                            value={props.attributes.font_family_tweet}
                                        />

                                        <SelectControl
                                            label="Font Weight"
                                          options={font_weight_list_twet}
                                            onChange={(new_val) => {
                                                props.setAttributes({ tweet_weight: new_val })
                                            }}
                                            value={props.attributes.tweet_weight}
                                        />

                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <p style={{ marginRight: 30 }}>Line Height</p>
                                            <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                                <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                            <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                                <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                            <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                                <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                            <Button id="tweetLineheihgtPx" onClick={tweetLineheihgtPx} primaray style={{fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                            <Button id="tweetLineheihgtEm" onClick={tweetLineheihgtEm} primaray style={{textDecoration: "underline", fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                        </div>

                                         <div  style={{display:"flex"}}>
                                        <div style={{marginRight:"10px",width:"100%"}}>
                                        <RangeControl 
                                            beforeIcon="editor-textcolor"
                                            step={0.1}
                                            initialPosition={1.5}
                                            min={0}
                                            max={100}
                                            onChange={(new_val) => {
                                                props.setAttributes({ line_height_tweet: new_val })
                                            }}
                                            value={props.attributes.line_height_tweet}
                                        />
                                        </div>

                                        <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({line_height_tweet:1.5})
                                            }}> Reset
                                        </Button>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                            <SelectControl
                                label="Target URL"
                                options={[
                                    { label: 'Current Page', value: 'current' },
                                    { label: 'Custom URL', value: 'custom' },
                                ]}
                                onChange={(new_val) => {
                                    props.setAttributes({ URL_value: new_val })
                                    url_value(new_val)
                                }}
                                value={props.attributes.URL_value}
                            />
                            <div id='custom-url' style={{ display: 'none' }}>
                                <TextControl
                                    label="URL"
                                    value={props.attributes.custom_url_value}
                                    onChange={(new_val) => {
                                        props.setAttributes({ custom_url_value: new_val })
                                    }}
                                />
                            </div>
                            <hr />
                            <div id="link_btn_padding">
                            <h2>Button Padding (px)</h2>
                            {<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.656-1.343-3-3-3v0z"></path><path fill="#575E67" d="M17 0.983h-14c-1.103 0-2 0.896-2 2v0.797h18v-0.797c0-1.103-0.896-2-2-2z"></path><path fill="#575E67" d="M3 19.031h14c1.103 0 2-0.896 2-2v-0.797h-18v0.797c0 1.104 0.896 2 2 2z"></path></svg>}
                            <div className="range-controler" style={{display:"flex"}}>
                            <div style={{marginRight:"10px",width:"100%"}}>
                            <RangeControl
                                step={0.1}
                                min={0}
                                max={50}
                                initialPosition={10}
                                value={props.attributes.padding_tb}
                                onChange={(new_val) => {
                                    props.setAttributes({ padding_tb: new_val })
                                }}
                            />
                            </div>
                            <Button style={{
                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba", marginTop:"23px"
                            }}
                            onClick={() => {
                            props.setAttributes({padding_tb:10})
                            }}> Reset 
                            </Button>
                            </div>

                            <div className="range-controler" style={{display:"flex"}}>
                            <div style={{marginRight:"10px",width:"100%"}}>
                            {<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.656 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M19.016 16.999v-14c0-1.103-0.896-2-2-2h-0.797v18h0.797c1.103 0 2-0.896 2-2z"></path><path fill="#575E67" d="M0.968 2.999v14c0 1.103 0.896 2 2 2h0.797v-18h-0.797c-1.104 0-2 0.897-2 2z"></path></svg>}
                            <RangeControl
                                min={0}
                                max={50}
                                step={0.1}
                                initialPosition={10}
                                value={props.attributes.padding_lr}
                                onChange={(new_val) => {
                                    props.setAttributes({ padding_lr: new_val })
                                }}
                            />
                            </div>
                            <Button style={{
                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                            }}
                            onClick={() => {
                            props.setAttributes({padding_lr:10})
                            }}> Reset 
                            </Button>
                            </div>
                            </div>

                            <p>Space between Tweet Icon and Text</p>
                            <div className="range-controler" style={{display:"flex"}}>
                            <div style={{marginRight:"10px",width:"100%"}}>
                            <RangeControl
                                step={0.1}
                                min={1}
                                max={20}
                                initialPosition={3}
                                value={props.attributes.icon_text_space}
                                onChange={(new_val) => {
                                    props.setAttributes({ icon_text_space: new_val })
                                }}
                            />
                            </div>
                            <Button style={{
                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                            }}
                            onClick={() => {
                            props.setAttributes({icon_text_space:3})
                            }}> Reset 
                            </Button>
                            </div>
                            <hr />
                            <div>
                                <div style={{ display: props.attributes.tweetDisplay }}>
                                    <TabPanel
                                        className="my-tab-panel"
                                        activeClass="active-tab"
                                        tabs={[
                                            {
                                                name: 'Normal',
                                                title: 'Tweet Color',
                                                className: <ColorPalette
                                                    colors={color_palette_list}
                                                    value={props.attributes.tweet_color}
                                                    onChange={(new_val) => {
                                                        props.setAttributes({ tweet_color: new_val })
                                                    }}
                                                />,
                                                value: <ColorIndicator colorValue={props.attributes.tweet_color} />
                                            },
                                            {
                                                name: 'Hover',
                                                title: 'Tweet Hover',
                                                className: <ColorPalette
                                                    colors={color_palette_list}
                                                    value={props.attributes.tweet_hover_color}
                                                    onChange={(new_val) => {
                                                        props.setAttributes({ tweet_hover_color: new_val })
                                                    }}
                                                />,
                                                value: <ColorIndicator colorValue={props.attributes.tweet_hover_color} />
                                            },
                                        ]}>
                                        {
                                            (tab) => <div >
                                                <br />
                                                <p>{tab.value} {tab.title}</p>
                                                <p>{tab.className}</p>
                                            </div>
                                        }
                                    </TabPanel>
                                    <TabPanel
                                        style={{ display: props.attributes.tweetDisplay }}
                                        className="my-tab-panel"
                                        activeClass="active-tab"
                                        tabs={[
                                            {
                                                name: 'Normal',
                                                title: 'Tweet Background',
                                                className: <ColorPalette
                                                    colors={color_palette_list}
                                                    value={props.attributes.tweet_background_color}
                                                    onChange={(new_val) => {
                                                        props.setAttributes({ tweet_background_color: new_val })
                                                    }}
                                                />,
                                                value: <ColorIndicator colorValue={props.attributes.tweet_background_color} />
                                            },
                                            {
                                                name: 'Hover',
                                                title: 'Background Hover',
                                                className: <ColorPalette
                                                    colors={color_palette_list}
                                                    value={props.attributes.tweet_background_hover_color}
                                                    onChange={(new_val) => {
                                                        props.setAttributes({ tweet_background_hover_color: new_val })
                                                    }}
                                                />,
                                                value: <ColorIndicator colorValue={props.attributes.tweet_background_hover_color} />
                                            },
                                        ]}>
                                        {
                                            (tab) => <div >
                                                <br />
                                                <p>{tab.value} {tab.title}</p>
                                                <p>{tab.className}</p>
                                            </div>
                                        }
                                    </TabPanel>
                                </div>
                                <div style={{ display: props.attributes.linkDisplay }}>
                                    <TabPanel
                                        className="my-tab-panel"
                                        activeClass="active-tab"
                                        tabs={[
                                            {
                                                name: 'Normal',
                                                title: 'Tweet Link',
                                                className: <ColorPalette
                                                    colors={color_palette_list}
                                                    value={props.attributes.link_tweet_color}
                                                    onChange={(new_val) => {
                                                        props.setAttributes({ link_tweet_color: new_val })
                                                    }}
                                                />,
                                                value: <ColorIndicator colorValue={props.attributes.link_tweet_color} />
                                            },
                                            {
                                                name: 'Hover',
                                                title: 'Link Hover',
                                                className: <ColorPalette
                                                    colors={color_palette_list}
                                                    value={props.attributes.link_tweet_hover_color}
                                                    onChange={(new_val) => {
                                                        props.setAttributes({ link_tweet_hover_color: new_val })
                                                    }}
                                                />,
                                                value: <ColorIndicator colorValue={props.attributes.link_tweet_hover_color} />
                                            },
                                        ]}>
                                        {
                                            (tab) => <div>
                                                <br />
                                                <p>{tab.value} {tab.title}</p>
                                                <p>{tab.className}</p>
                                            </div>
                                        }
                                    </TabPanel>
                                </div>
                            </div>
                        </div>
                    </PanelBody>
                    <PanelBody title={__('Spacing', 'block-list')} initialOpen={false}>
                        <p>Gap Between Border and Quote</p>
                        <div className="range-controler" style={{display:"flex"}}>
                        <div style={{marginRight:"10px",width:"100%"}}>
                        <RangeControl
                            step={0.1}
                            min={0}
                            max={500}
                            initialPosition={15}
                            value={props.attributes.border_quote_gap}
                            onChange={(new_val) => {
                                props.setAttributes({ border_quote_gap: new_val })
                            }}
                        />
                        </div>
                        <Button style={{
                        background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                        }}
                        onClick={() => {
                        props.setAttributes({border_quote_gap:15})
                        }}> Reset 
                        </Button>
                        </div>
                        
                        <p>Quote Bottom Spacing</p>
                        <div className="range-controler" style={{display:"flex"}}>
                        <div style={{marginRight:"10px",width:"100%"}}>
                        <RangeControl
                            step={0.1}
                            min={0}
                            max={200}
                            initialPosition={0}
                            value={props.attributes.quote_bottom_spacing}
                            onChange={(new_val) => {
                                props.setAttributes({ quote_bottom_spacing: new_val })
                            }}
                        />
                         </div>
                        <Button style={{
                        background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                        }}
                        onClick={() => {
                        props.setAttributes({quote_bottom_spacing:0})
                        }}> Reset 
                        </Button>
                        </div>

                        <hr />

                        <h2>Vertical Padding</h2>
                        {<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.656-1.343-3-3-3v0z"></path><path fill="#575E67" d="M17 0.983h-14c-1.103 0-2 0.896-2 2v0.797h18v-0.797c0-1.103-0.896-2-2-2z"></path><path fill="#575E67" d="M3 19.031h14c1.103 0 2-0.896 2-2v-0.797h-18v0.797c0 1.104 0.896 2 2 2z"></path></svg>}
                        <div className="range-controler" style={{display:"flex"}}>
                        <div style={{marginRight:"10px",width:"100%"}}>
                        <RangeControl
                            step={0.1}
                            min={0}
                            max={500}
                            initialPosition={0}
                            value={props.attributes.vertical_padding}
                            onChange={(new_val) => {
                                props.setAttributes({ vertical_padding: new_val })
                            }}
                        />
                         </div>
                        <Button style={{
                        background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                        }}
                        onClick={() => {
                        props.setAttributes({vertical_padding:0})
                        }}> Reset 
                        </Button>
                        </div>
                    </PanelBody>
                </InspectorControls >

                    {/* Main Div */}
                <div className={props.className}>
                <div className="gb-block-quote-wrapper"
                    onMouseOver={changeBorder} onMouseLeave={sameColor}
                    style={{
                        borderColor: props.attributes.border_color,
                        borderLeftStyle: props.attributes.qoute_border_style,
                        borderLeftWidth: props.attributes.border_width,
                        paddingLeft: props.attributes.border_quote_gap,
                        paddingTop: props.attributes.vertical_padding,
                        paddingBottom: props.attributes.vertical_padding,
                    }}>
                   
                    {/* Quotation */}
                    <Dashicon className="gb-block-quote-quote" icon='format-quote'
                        onMouseOver={onChangeIcon}
                        onMouseLeave={sameIcon}
                        style={{
                            width: 'auto',
                            height: 'auto',
                            fontSize: props.attributes.quote_icon_size+props.attributes.qouteicon_px_em,
                            padding: props.attributes.icon_background_size+props.attributes.bgqouteicon_px_em,
                            borderRadius: props.attributes.quote_border_radius + '%',
                            background: props.attributes.quote_icon_background_color,
                            marginRight: '20px',
                            display: props.attributes.quoteDisp,
                            float: 'left',
                            color: props.attributes.quote_icon_color,
                        }}
                    />
                    {/* Rich Text */}
                    <RichText
                        className="gb-block-quote-quote-text"
                        id='quote-text'
                        style={{
                            fontSize: props.attributes.quote_size+props.attributes.quoteFontEm_pxem,
                            fontFamily: props.attributes.font_family_quote,
                            fontWeight: props.attributes.quote_weight,
                            lineHeight: props.attributes.line_height_quote+props.attributes.line_height_px_em,
                            color: props.attributes.quote_color,
                        }}
                        value={props.attributes.quotation}
                        onChange={(new_val) => {
                            props.setAttributes({ quotation: new_val })
                        }} />
                    {/* footer Div */}
                    <div className="gb-block-quote-footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: props.attributes.quote_bottom_spacing }}>
                        <div className="gb-block-quote-author-section" style={{ display: 'flex', flexDirection: props.attributes.author_img_position, alignItems: "center", justifyContent: 'space-around', }}>
                            <img
                                className="gb-block-quote-author-img"
                                id='show-img'
                                style={{
                                    width: props.attributes.author_img_width,
                                    height: props.attributes.author_img_width,
                                    borderRadius: props.attributes.author_img_border_radius,
                                    objectFit: props.attributes.author_img_size,
                                    margin: '0px 10px'
                                }} 
                                src={props.attributes.img_URL}
                                alt={props.attributes.img_alt}
                                >
                                </img>
                            <RichText
                                className="gb-block-quote-author-text"
                                id='author'
                                style={{
                                    display: 'inline-block',
                                    fontSize: props.attributes.author_size+props.attributes.autorsize_px_em,
                                    fontFamily: props.attributes.font_family_author,
                                    fontWeight: props.attributes.author_weight,
                                    lineHeight: props.attributes.line_height_author+props.attributes.lineheightauthor_px,
                                    color: props.attributes.author_color,
                                }}
                                value={props.attributes.author_name}
                                onChange={(new_val) => {
                                    props.setAttributes({ author_name: new_val })
                                }} />
                        </div>
                        <div className="gb-block-quote-tweet-section" style={{ display: props.attributes.twitterDisp }}>
                           <div style={{display: props.attributes.tweetDisplay}}>
                            <Dashicon
                                className="gb-block-quote-tweet-bubble"
                                onMouseOver={onChnageBubble}
                                onMouseLeave={sameBubble}
                                style={{
                                    color: props.attributes.tweet_background_color,
                                    marginRight: '-8px',
                                    display: props.attributes.bubbleDisp,
                                    paddingTop: props.attributes.padding_tb + 4,
                                    fontSize: props.attributes.tweet_size + props.attributes.tweet_px_em_size,
                                    lineHeight: props.attributes.line_height_tweet + props.attributes.tweelineheightpxem
                                }}
                                icon='arrow-left' />
                            <a href={props.attributes.custom_url_value} target='_blank'
                                className="gb-block-quote-tweet-link"
                                onMouseOver={onChnageTweet}
                                onMouseLeave={sameTweet}
                                style={{
                                    textDecoration: 'none',
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: props.attributes.tweet_color,
                                    backgroundColor: props.attributes.tweet_background_color,
                                    paddingTop: props.attributes.padding_tb,
                                    paddingBottom: props.attributes.padding_tb,
                                    paddingLeft: props.attributes.padding_lr,
                                    paddingRight: props.attributes.padding_lr,
                                    float: 'right',
                                    borderRadius: '40px',
                                    fontSize: '13px'
                                }}>
                                <Dashicon
                                    onMouseOver={onChnageTweetIcon}
                                    onMouseLeave={sameTweetIcon}
                                    className='gb-block-quote-tweet-icon'
                                    style={{
                                        marginRight: props.attributes.icon_text_space,
                                        fontSize: props.attributes.tweet_size + props.attributes.tweet_px_em_size,
                                        width: 'auto',
                                        height: 'auto',
                                        fontWeight: props.attributes.tweet_weight,
                                        lineHeight: props.attributes.line_height_tweet + props.attributes.tweelineheightpxem,
                                        display: props.attributes.tweetIcon
                                    }}
                                    icon='twitter' />
                                <span
                                    className="gb-block-quote-tweet-text"
                                    onMouseOver={onChnageTweetText}
                                    onMouseLeave={sameTweetText}
                                    style={{
                                        color: props.attributes.tweet_color,
                                        fontSize: props.attributes.tweet_size + props.attributes.tweet_px_em_size,
                                        fontFamily: props.attributes.font_family_tweet,
                                        fontWeight: props.attributes.tweet_weight,
                                        lineHeight: props.attributes.line_height_tweet + props.attributes.tweelineheightpxem,
                                        display: props.attributes.tweet
                                    }} >{props.attributes.label_value}</span>
                            </a>
                        </div>
                        <div
                            className="gb-block-quote-link-section"
                            style={{ display: props.attributes.linkDisplay, marginRight: '20px' }}>
                            <a className="gb-block-quote-link-anchor">
                                <Dashicon
                                    onMouseOver={onChnageTweetLink}
                                    onMouseLeave={sameTweetLink}
                                    className="gb-block-quote-link-icon"
                                    style={{
                                        marginRight: props.attributes.icon_text_space,
                                        fontSize: props.attributes.tweet_size + props.attributes.tweet_px_em_size,
                                        width: 'auto',
                                        height: 'auto',
                                        color: props.attributes.link_tweet_color,
                                        fontFamily: props.attributes.font_family_tweet,
                                        fontWeight: props.attributes.tweet_weight,
                                        lineHeight: props.attributes.line_height_tweet+props.attributes.tweetLineheihgtPx
                                        ,
                                        marginTop:"10px"
                                    }}
                                    icon='twitter' />
                                <span
                                    className="gb-block-quote-link-text"
                                    onMouseOver={onChnageTweetLink}
                                    onMouseLeave={sameTweetLink}
                                    style={{
                                        color: props.attributes.link_tweet_color,
                                        fontSize: props.attributes.tweet_size + props.attributes.tweet_px_em_size,
                                        fontFamily: props.attributes.font_family_tweet,
                                        fontWeight: props.attributes.tweet_weight,
                                        lineHeight: props.attributes.line_height_tweet+props.attributes.tweetLineheihgtPx,
                                        display: props.attributes.tweet
                                    }}
                                >{props.attributes.label_value}</span>
                            </a>
                        </div>
                        </div>
                    </div>
                </div>
                </div>
            </React.Fragment>
        )
    },
    save: (props) => {
        return (
            <div className={props.className}>
                <div className="gb-block-quote-wrapper"
                    style={{
                        borderColor: props.attributes.border_color,
                        borderLeftStyle: props.attributes.qoute_border_style,
                        borderLeftWidth: props.attributes.border_width,
                        paddingLeft: props.attributes.border_quote_gap,
                        paddingTop: props.attributes.vertical_padding,
                        paddingBottom: props.attributes.vertical_padding,
                    }}>
                   
                    {/* Quotation */}
                    <Dashicon className="gb-block-quote-quote" icon='format-quote'
                        style={{
                            width: 'auto',
                            height: 'auto',
                            fontSize: props.attributes.quote_icon_size+props.attributes.qouteicon_px_em,
                            padding: props.attributes.icon_background_size+props.attributes.bgqouteicon_px_em,
                            borderRadius: props.attributes.quote_border_radius + '%',
                            background: props.attributes.quote_icon_background_color,
                            marginRight: '20px',
                            display: props.attributes.quoteDisp,
                            float: 'left',
                            color: props.attributes.quote_icon_color,
                        }}
                    />
                    {/* Rich Text */}
                    <RichText.Content
                        className="gb-block-quote-quote-text"
                        id='quote-text'
                        style={{
                            fontSize: props.attributes.quote_size+props.attributes.quoteFontEm_pxem,
                            fontFamily: props.attributes.font_family_quote,
                            fontWeight: props.attributes.quote_weight,
                            lineHeight: props.attributes.line_height_quote+props.attributes.line_height_px_em,
                            color: props.attributes.quote_color,
                        }}
                        value={props.attributes.quotation}
                        />

                    {/* footer Div */}
                    <div className="gb-block-quote-footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: props.attributes.quote_bottom_spacing }}>
                        <div className="gb-block-quote-author-section" style={{ display: 'flex', flexDirection: props.attributes.author_img_position, alignItems: "center", justifyContent: 'space-around', }}>
                            <img
                                className="gb-block-quote-author-img"
                                id='show-img'
                                style={{
                                    width: props.attributes.author_img_width,
                                    height: props.attributes.author_img_width,
                                    borderRadius: props.attributes.author_img_border_radius,
                                    objectFit: props.attributes.author_img_size,
                                    margin: '0px 10px'
                                }} 
                                src={props.attributes.img_URL}
                                alt={props.attributes.img_alt}
                                >
                                </img>
                            <RichText.Content
                                className="gb-block-quote-author-text"
                                id='author'
                                style={{
                                    display: 'inline-block',
                                    fontSize: props.attributes.author_size+props.attributes.autorsize_px_em,
                                    fontFamily: props.attributes.font_family_author,
                                    fontWeight: props.attributes.author_weight,
                                    lineHeight: props.attributes.line_height_author+props.attributes.lineheightauthor_px,
                                    color: props.attributes.author_color,
                                }}
                                value={props.attributes.author_name}
                                />
                        </div>
                        <div className="gb-block-quote-tweet-section" style={{ display: props.attributes.twitterDisp }}>
                           <div style={{display: props.attributes.tweetDisplay}}>
                            <Dashicon
                                className="gb-block-quote-tweet-bubble"
                                style={{
                                    color: props.attributes.tweet_background_color,
                                    marginRight: '-8px',
                                    display: props.attributes.bubbleDisp,
                                    paddingTop: props.attributes.padding_tb + 4,
                                    fontSize: props.attributes.tweet_size + props.attributes.tweet_px_em_size,
                                    lineHeight: props.attributes.line_height_tweet + props.attributes.tweelineheightpxem
                                }}
                                icon='arrow-left' />
                            <a href={props.attributes.custom_url_value} target='_blank'
                                className="gb-block-quote-tweet-link"
                                style={{
                                    textDecoration: 'none',
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: props.attributes.tweet_color,
                                    backgroundColor: props.attributes.tweet_background_color,
                                    paddingTop: props.attributes.padding_tb,
                                    paddingBottom: props.attributes.padding_tb,
                                    paddingLeft: props.attributes.padding_lr,
                                    paddingRight: props.attributes.padding_lr,
                                    float: 'right',
                                    borderRadius: '40px',
                                    fontSize: '13px'
                                }}>
                                <Dashicon
                                    className='gb-block-quote-tweet-icon'
                                    style={{
                                        marginRight: props.attributes.icon_text_space,
                                        fontSize: props.attributes.tweet_size + props.attributes.tweet_px_em_size,
                                        width: 'auto',
                                        height: 'auto',
                                        fontWeight: props.attributes.tweet_weight,
                                        lineHeight: props.attributes.line_height_tweet + props.attributes.tweelineheightpxem,
                                        display: props.attributes.tweetIcon
                                    }}
                                    icon='twitter' />
                                <span
                                    className="gb-block-quote-tweet-text"
                                    style={{
                                        color: props.attributes.tweet_color,
                                        fontSize: props.attributes.tweet_size + props.attributes.tweet_px_em_size,
                                        fontFamily: props.attributes.font_family_tweet,
                                        fontWeight: props.attributes.tweet_weight,
                                        lineHeight: props.attributes.line_height_tweet + props.attributes.tweelineheightpxem,
                                        display: props.attributes.tweet
                                    }} >{props.attributes.label_value}</span>
                            </a>
                        </div>
                        <div
                            className="gb-block-quote-link-section"
                            style={{ display: props.attributes.linkDisplay, marginRight: '20px' }}>
                            <a className="gb-block-quote-link-anchor">
                                <Dashicon
                                    className="gb-block-quote-link-icon"
                                    style={{
                                        marginRight: props.attributes.icon_text_space,
                                        fontSize: props.attributes.tweet_size + props.attributes.tweet_px_em_size,
                                        width: 'auto',
                                        height: 'auto',
                                        color: props.attributes.link_tweet_color,
                                        fontFamily: props.attributes.font_family_tweet,
                                        fontWeight: props.attributes.tweet_weight,
                                        lineHeight: props.attributes.line_height_tweet+props.attributes.tweetLineheihgtPx
                                        ,
                                        marginTop:"10px"
                                    }}
                                    icon='twitter' />
                                <span
                                    className="gb-block-quote-link-text"
                                    style={{
                                        color: props.attributes.link_tweet_color,
                                        fontSize: props.attributes.tweet_size + props.attributes.tweet_px_em_size,
                                        fontFamily: props.attributes.font_family_tweet,
                                        fontWeight: props.attributes.tweet_weight,
                                        lineHeight: props.attributes.line_height_tweet+props.attributes.tweetLineheihgtPx,
                                        display: props.attributes.tweet
                                    }}
                                >{props.attributes.label_value}</span>
                            </a>
                        </div>
                        </div>
                    </div>
                </div>
                </div>
        )
    }
})